module.exports = __webpack_public_path__ + "assets/img/echartsNone.1c2181fe.png";